<template>
  <draggable class="page-menu-list" tag="div" :list="menuPageList" handle=".menu">
    <div
      v-for="(menuPage) in menuPageList"
      class="menu"
      :key="menuPage.id"
      :ref="`menuPage_${menuPage.id}`"
      :style="{'--menu-width': `${widthMap[menuPage.id]}px`, '--current-color': colorMap[menuPage.id], '--parent-color': parentColor || defaultColor}"
    >
      <div class="menu-head">
        <div class="menu-name">
          <span v-if="menuPage.label.isRichText" v-html="menuPage.label.html" class="name-html"></span>
          <span v-else>{{ menuPage.label.text }}</span>
          <div class="btn add-btn" @click="onAddClick(menuPage)">
            <i class="btn-icon el-icon-circle-plus-outline"></i>
          </div>
        </div>
        <div class="btn edit-btn" @click="onEditClick(menuPage)">
          <i class="btn-icon el-icon-edit"></i>
        </div>
        <div v-if="menuPage.menu.isActive && menuPage.menu.list.length > 0" class="btn expand-btn" @click="onExpandClick(menuPage)">
          <i v-if="menuPage.menu.isExpand" class="btn-icon el-icon-remove-outline"></i>
          <span v-else class="btn-icon is-collapse">{{ menuPage.menu.list.length }}</span>
        </div>
      </div>
      <draggable-page-menu
        v-show="menuPage.menu.isActive && menuPage.menu.isExpand"
        class="children"
        :parent-color="colorMap[menuPage.id]"
        :menu-page-list="menuPage.menu.list"
        :parentMenuPage="menuPage"
        @add="onAddClick"
        @edit="onEditClick"
        @delete="onDeleteClick"
        @expand="onExpandClick"
        @active="onActiveClick"
      />
    </div>
  </draggable>
</template>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'

export default {
  name: 'draggable-page-menu',
  components: {
    draggable
  },
  props: {
    parentMenuPage: {
      type: Object,
      required: false
    },
    menuPageList: {
      required: true,
      type: Array
    },
    parentColor: {
      default: null
    }
  },
  data () {
    const colorList = ['#E95280', '#23B1A5', '#FFDD7E', '#614BC3', '#333333']
    return {
      colorList,
      defaultColor: colorList[0],
      colorIndex: 1,
      colorMap: {},
      widthWatchMap: {},
      widthMap: {}
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.resetDataMap()
  },
  methods: {
    resetDataMap () {
      this.widthMap = {}
      const widthWatchMap = {}
      const colorMap = {}
      const vm = this
      _.forEach(this.menuPageList, async (menuPage) => {
        let ref = this.$refs[`menuPage_${menuPage.id}`]
        if (!ref) {
          await this.$nextTick()
          ref = this.$refs[`menuPage_${menuPage.id}`]
        }
        if (!ref) {
          return
        }
        const widthGetter = async () => {
          await this.$nextTick()
          const menuRef = this.$refs[`menuPage_${menuPage.id}`]
          const el = menuRef[0].querySelector('.menu-head .menu-name')
          const style = window.getComputedStyle(el)
          const marginLeft = parseFloat(style.marginLeft.replace('pk', ''))
          this.$set(this.widthMap, menuPage.id, marginLeft + el.clientWidth / 2)
        }
        widthWatchMap[menuPage.id] = this.$watch(() => menuPage.label.text || menuPage.label.html, widthGetter, { immediate: true })

        if (this.parentMenuPage) {
          Object.defineProperty(colorMap, menuPage.id, {
            configurable: true,
            enumerable: true,
            get () {
              return vm.parentColor
            }
          })
        } else {
          colorMap[menuPage.id] = this.getNextColor()
        }
      })
      _.forEach(this.widthWatchMap, unwatch => unwatch && unwatch())
      this.widthWatchMap = widthWatchMap
      this.colorMap = colorMap
    },
    getNextColor () {
      let colorIndex = this.colorIndex
      const color = this.colorList[colorIndex]
      colorIndex += 1
      if (colorIndex >= this.colorList.length) {
        colorIndex = 0
      }
      this.colorIndex = colorIndex
      return color
    },
    getBorderBottomColor (menuPage, index) {
      if (!this.borderLeftColor) {
        this.borderLeftColor = this.getNextColor()
      }
      const id = menuPage.id
      if (!this.borderBottomColorMap[id]) {
        this.borderBottomColorMap[id] = this.getNextColor()
      }
      return this.borderBottomColorMap[id]
    },
    onAddClick (menuPage, index, parentMenuPage) {
      if (!parentMenuPage) {
        parentMenuPage = this.parentMenuPage
      }
      this.$emit('add', menuPage, index, parentMenuPage)
    },
    onEditClick (menuPage, index, parentMenuPage) {
      if (!parentMenuPage) {
        parentMenuPage = this.parentMenuPage
      }
      this.$emit('edit', menuPage, index, parentMenuPage)
    },
    onDeleteClick (menuPage, index, parentMenuPage) {
      if (!parentMenuPage) {
        parentMenuPage = this.parentMenuPage
      }
      this.$emit('delete', menuPage, index, parentMenuPage)
    },
    onExpandClick (menuPage, index, parentMenuPage) {
      if (!parentMenuPage) {
        parentMenuPage = this.parentMenuPage
      }
      this.$emit('expand', menuPage)
    },
    onActiveClick (menuPage, index, parentMenuPage) {
      if (!parentMenuPage) {
        parentMenuPage = this.parentMenuPage
      }
      this.$emit('active', menuPage)
    }
  },
  watch: {
    menuPageList () {
      this.$nextTick(() => {
        this.resetDataMap()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-menu-list {
  &.children {
    .menu {
      .menu-head {
        .menu-name {
          padding-bottom: 0;
          border-bottom: 0;
        }
      }
    }
  }
  .menu {
    width: max-content;
    max-width: 100%;
    position: relative;
    &:first-child {
      .menu-head {
        .head-line {
          &.menu-name {
            // padding-top: 20px;
          }
        }
      }
    }
    &:last-child {
      .children {
        border-left: 0;
      }
    }
    .menu-head {
      width: max-content;
      max-width: 100%;
      border-left: 1px solid var(--parent-color);
      border-bottom: 1px solid var(--current-color);
      position: relative;
      .menu-name {
        line-height: 24px;
        margin-left: 16px;
        margin-bottom: 4px;
        padding: 22px 20px 4px;
        border-bottom: 1px solid var(--current-color);
        background: #fff;
        position: relative;
        &:hover {
          .add-btn {
            opacity: 1;
          }
        }
        .name-html {
          ::v-deep {
            > p {
              line-height: initial;
            }
            p {
              margin: 0;
            }
          }
        }
        .add-btn {
          color: #0096cc;
          font-size: 18px;
          opacity: 0;
          transform: translateY(calc((22px - 100%) / 2));
          z-index: 1;
          top: 50%;
          right: -20px;
        }
      }
      .btn {
        font-size: 14px;
        background: #fff;
        transition: opacity .3s;
        position: absolute;
        cursor: pointer;
        .btn-icon {
          display: block;
        }
      }
      .edit-btn {
        top: 18px;
        right: 6px;
      }
      .expand-btn {
        opacity: 1;
        transform: translateX(-50%);
        bottom: -20px;
        left: var(--menu-width);
        z-index: 1;
        &:hover {
          opacity: 1;
        }
        .btn-icon {
          color: var(--current-color);
          &.is-collapse {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            border: 1px solid var(--current-color);
            line-height: 12px;
            font-size: 12px;
            text-align: center;
            &::before {
              content: '';
              display: block;
              width: 1px;
              height: 6px;
              background: var(--current-color);
              position: absolute;
              top: -5px;
              left: 50%;
            }
          }
        }
      }
    }
    .children {
      padding-left: var(--menu-width);
      border-left: 1px solid var(--parent-color);
    }
  }
}
</style>
